import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { firebaseAuthObj } from 'lib/firebase';

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_NAPI_URL,
        async prepareHeaders(headers) {
            let token;
            if (firebaseAuthObj) {
                const user = firebaseAuthObj.currentUser;
                // fb-tokens expire after 1 hour. Make sure we have a fresh/valid token before making requests.
                if (user) token = await user.getIdToken();
            }

            if (process.env.REACT_APP_NAPI_API_KEY) {
                headers.set('x-apikey', process.env.REACT_APP_NAPI_API_KEY);
            }

            if (token && !process.env.REACT_APP_NAPI_API_KEY) {
                headers.set('x-fb-token', token);
            }

            return headers;
        },
    }),
    endpoints: () => ({}),
});
